if(window.location.host=='www.9hier.com'){
    document.getElementsByTagName("title")[0].innerHTML="全球生命纪念馆";
}else if(window.location.host=='guangxi.9hier.com'){
    document.getElementsByTagName("title")[0].innerHTML="全球生命纪念馆";
}else{
    document.getElementsByTagName("title")[0].innerHTML="九何时空";
}



// WEBPACK FOOTER //
// ./src/config/project.js